import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Select, Avatar } from "antd";
import AddSubAdmin from "./AddSubAdmin";
import { Error } from "../../../commons/Messages/Messages";
import axios from "axios";
import EditSubAdmin from "./EditSubAdmin";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import defaultImage from "../../../commons/PanelAssets/img/doctors/doctor-01.jpg";
import DropdownComp from "../../../commons/Dropdowns/DropdownComp";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import GeneralTable from "../../../commons/GeneralTable";
import PageToolbar from "../../../design-system/PageToolbar";
import "./SubAdmin.css";

import { useTranslation } from "react-i18next";
const SubAdminList = () => {
  const { t } = useTranslation("dashboard");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(6);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      mobile: "title",
      render: (text, record) => (
        <Link to="/app/subadmin/subadmin-profile" className="subadmins-page__person">
          <Avatar size={40} src={record.picture ? record.picture?.url : defaultImage} alt="" />
          <span>
            {record.firstName} {record.lastName}
          </span>
        </Link>
      ),
      sorter: (a, b) => a.firstName.localeCompare(b.firstName)
    },
    {
      title: t("Email"),
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length
    },
    {
      title: t("Phone"),
      dataIndex: "phone",
      sorter: (a, b) => a.mobile.length - b.mobile.length
    },
    {
      title: t("Status"),
      dataIndex: "status",
      render: () => (
        <Select
          className="subadmins-page__status"
          aria-label={t("Status")}
          defaultValue="Active"
          onChange={() => undefined}
          options={[
            { value: "Active", label: t("Active") },
            { value: "Inactive", label: t("Inactive") }
          ]}
        />
      )
    },
    {
      title: t("Action"),
      key: "action",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "edit",
            component: () => <EditSubAdmin data={obj} updateParent={getData} />
          },
          {
            key: "delete",
            component: () => <DeleteModal text="Subadmin" onClick={() => undefined} />
          }
        ];
        return <DropdownComp menuItems={menuItems} />;
      }
    }
  ];

  const getData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/users/subadmins`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      });
      setLoading(false);
      if (res.status === 200 || res.status === 304) {
        setData(res.data);
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      setLoading(false);
      Error(err.response?.data?.errorMessage || err.message);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="subadmins-page">
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={<AddSubAdmin updateParent={getData} />}
      />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        loading={loading}
        setPageNo={setPageNo}
      />
    </div>
  );
};

export default SubAdminList;
